import { render } from "./CrusadeType.vue?vue&type=template&id=5ac6f826"
import script from "./CrusadeType.vue?vue&type=script&lang=js"
export * from "./CrusadeType.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__